module.exports = __webpack_public_path__ + "media/concert-crowd.0f99fee7.ogg";